import { Component } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';

@Component({
  selector: 'l-status-tooltip, [lStatusTooltip]',
  standalone: true,
  templateUrl: './status-tooltip.component.html',
  imports: [IconComponent],
})
export class StatusTooltipComponent {}
